import { Box, Button, Group, Text } from '@mantine/core';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onRetry?: () => void;
  disabled?: boolean;
};

export function ChatErrorBubble({ onRetry, disabled }: Props) {
  return (
    <Box
      px="md"
      py="sm"
      style={{
        borderRadius: 20,
        border: '1px solid var(--mantine-color-red-4)',
        backgroundColor: 'var(--mantine-color-red-0)',
      }}
    >
      <Group gap="xs" wrap="nowrap" align="flex-start">
        <IconAlertCircle
          size={18}
          color="var(--mantine-color-red-6)"
          style={{ flexShrink: 0, marginTop: 2 }}
        />
        <Box>
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="red.7">
            Something went wrong generating this response. Please try again. If it keeps happening,
            contact support.
          </Text>
          {onRetry && (
            <Button
              mt="sm"
              size="xs"
              variant="light"
              color="red"
              leftSection={<IconRefresh size={14} />}
              onClick={onRetry}
              disabled={disabled}
            >
              Retry
            </Button>
          )}
        </Box>
      </Group>
    </Box>
  );
}
